import { render, staticRenderFns } from "./ViHomeOthers.vue?vue&type=template&id=301491bc&scoped=true"
import script from "./ViHomeOthers.vue?vue&type=script&lang=js"
export * from "./ViHomeOthers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "301491bc",
  null
  
)

export default component.exports